import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const facebooklLogin = graphql(
  gql`
    mutation FacebookSignIn(
      $token: String!,
      $countryCode: String,
      $countryName: String, 
      $regionName: String,
      $city: String,
      $isLoginIn: Boolean,
      $device: String,
      $source: String,
      $byManager: String,
      $utmSource: String
    ) {
      facebookSignIn(
        token: $token,
        countryCode: $countryCode,
        countryName: $countryName,
        regionName: $regionName,
        city: $city,
        isLoginIn: $isLoginIn,
        device: $device,
        source: $source,
        byManager: $byManager,
        utmSource: $utmSource
      ) {
        user {
          id
          shortId: short_id
          name: first_name
          lastName: last_name
          email
          administrator
          triggerWelcome: trigger_welcome
        }
        token
        newUser
        cart
        deprecated
      }
    }
  `,
  {
    name: 'loginWithFacebook'
  }
)

export const googleLogin = graphql(
  gql`
    mutation GoogleSignIn(
      $token: String!
      $countryCode: String
      $isAdmin: Boolean!
      $countryName: String
      $regionName: String
      $city: String
      $isLoginIn: Boolean
      $device: String
      $source: String
      $byManager: String
      $affiliate: String
      $accountManager: String
      $salesRepAssign: String
      $utmSource: String
    ) {
      googleSignIn(
        token: $token
        countryCode: $countryCode
        isAdmin: $isAdmin
        countryName: $countryName
        regionName: $regionName
        city: $city
        isLoginIn: $isLoginIn
        device: $device
        source: $source
        byManager: $byManager
        affiliate: $affiliate
        accountManager: $accountManager
        salesRepAssign: $salesRepAssign
        utmSource: $utmSource
      ) {
        user {
          id
          shortId: short_id
          archived
          name: first_name
          lastName: last_name
          email
          administrator
          triggerWelcome: trigger_welcome
        }
        token
        newUser
        cart
      }
    }
  `,
  {
    name: 'loginWithGoogle'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FacebookGmailLogin/data.ts